<template>
  <div id="app">
      <div class="header">
        <div class="columns is-vcentered">
          <div class="column is-2">
              <h2 class="title italic">SPI<span class="yellow" style="transform: scale(1.2);
    display: inline-block; padding-right:1px;">N</span>R</h2>
          </div>
          <div class="column has-text-centered has-text-white">
            <p><strong class="has-text-white">Spun <span class="yellow">{{ numRandomisedWords }} areas</span>, with <span class="yellow">{{ possibleRandomisedWords }} options</span>, a total of <span class="yellow">{{ totalPossibilities }} possible variants</span>.</strong></p>
          </div>
          <div class="column has-text-right is-2">
              <button class="button" @click="performRegEx">Spin Content!</button>
          </div>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column">
          <div class="in">
            <textarea class="textarea" name="input" id="" cols="30" rows="10" v-model="input"></textarea>
          </div>
        </div>
        <div class="column">
          <div class="out">
            <textarea class="textarea" name="output" id="" cols="30" rows="10" v-html="output"></textarea>
          </div>
        </div>
        <div class="column is-3">
          <div class="help">
            <Synonyms/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Synonyms from './components/Synonyms';
export default {
  name: 'app',
  data() {
    return {
      input: 'Enter your {{content|text|wording}}, formatted with curly brackets and pipes {{separating|splitting}} each possible outcome. For {{example|demonstration|instance}}..',
      output: null,
      numRandomisedWords: 0,
      possibleRandomisedWords: 0,
      totalPossibilities: 0
    }
  },
  components: {
    Synonyms
  },
  methods: {
    randomNumber(max) {
      return Math.floor(Math.random() * max);
    },
    performRegEx() {
      this.possibleRandomisedWords = 0;
      this.numRandomisedWords = 0;
      this.totalPossibilities = 0;
      this.output = this.input;
      const regex = /({{.+?}})/g;
      const matches = this.input.match(regex);
      //  console.log(matches);

      matches.forEach(match => {
        this.output = this.output.replace(match, this.selectWord(match));
        this.numRandomisedWords++;
      });
    },
    selectWord(choice) {
      // Let's strip the brackets.
      choice = choice.replace('{{', '');
      choice = choice.replace('}}', '');
      choice = choice.split('|');

      this.possibleRandomisedWords += choice.length;

      this.totalPossibilities = (this.totalPossibilities < 1) ? this.totalPossibilities = 1 : this.totalPossibilities = this.totalPossibilities;
      this.totalPossibilities = this.totalPossibilities * choice.length;

      const r = this.randomNumber(choice.length);

      return `${choice[r]}`;
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.italic {
  font-style: italic;
  font-family: 'Josefin Sans', sans-serif;
}

.yellow {
  color: #ffdd57;
}

.in, .out {
  padding: 30px;
}

.out {
  background: #f5f5f5;
  height: 100vh;
}

.button {
  background: #ffdd57 !important;
  border: none !important;
  font-weight: bold;
  color: purple !important;
}

textarea {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    resize: none;
    // overflow: scroll;
    border: none !important;
    height: 100vh !important;
    line-height: 30px;
}

.header {
  background: rgb(64,31,146);
  background: linear-gradient(48deg, rgba(64,31,146,1) 0%, rgba(118,39,192,1) 50%);
  // margin-bottom: 12px;
  padding: 20px;

  h2 {
    color: white;
  }
}

.out {
  textarea {
    background: transparent;
  }
}

.help {
  padding: 30px;
  margin-top: 0px !important;
  background: #431f95;
  height: 100vh;
  overflow: scroll;
  -ms-overflow-style: none;

  .box {
    margin-bottom: 30px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
